import { ReportFilterV2 } from "@/common/report-configuration";
import { FilterDropdown } from "./FilterDropdown";
import { DatasetName } from "@/common/constants.ts";
import { FILTERS } from "@/common/filters";
import { useCallback } from "react";
import { useCurrentWorkspace } from "@/store/authContext/authContext";
import { ReportStateReducerActionType } from "@/common/reportDesignerStateReducer.ts";

export const ActiveFiltersV2: React.FC<{
  filters: ReportFilterV2[];
  datasetName: DatasetName;
  newFilterField: string | null;
  reportDesignerDispatch?: React.Dispatch<ReportStateReducerActionType>;
  disabled?: boolean;
}> = ({
  filters,
  datasetName,
  newFilterField,
  reportDesignerDispatch: dispatch,
  disabled,
}) => {
  const currentWorkspace = useCurrentWorkspace();
  const onFilterChange = useCallback(
    (index: number, newFilter: ReportFilterV2) => {
      dispatch?.({
        type: "updateFilterByIndex",
        payload: { index, newFilter },
      });
    },
    [dispatch],
  );

  return (
    <div className="flex flex-wrap gap-2 mb-4 pl-3">
      {filters.map((filter, index) => {
        const V2Filter = FILTERS[filter.filterDefinitionName];

        if (!V2Filter || !V2Filter.datasetName.includes(datasetName)) {
          return null;
        }
        if (
          currentWorkspace.dataset_field_configs[datasetName]
            ?.fieldNameOverrides?.[filter.filterDefinitionName]
        ) {
          V2Filter.label =
            currentWorkspace.dataset_field_configs[
              datasetName
            ].fieldNameOverrides[filter.filterDefinitionName]!;
        }

        return (
          <div key={filter.filterDefinitionName}>
            <FilterDropdown
              displayName={V2Filter.label}
              V2Filter={filter}
              onFilterChange={(newFilter) => onFilterChange(index, newFilter)}
              datasetName={datasetName!}
              defaultOpen={filter.filterDefinitionName === newFilterField}
              disabled={disabled}
            />
          </div>
        );
      })}
    </div>
  );
};
